import { render, staticRenderFns } from "./IconReview.vue?vue&type=template&id=a08d7868&functional=true"
import script from "./IconReview.vue?vue&type=script&lang=js"
export * from "./IconReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports